import Service, { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { queryManager } from 'ember-apollo-client';

import GetVoucherById from 'my-phorest/gql/queries/get-voucher-by-id.graphql';
import GetVoucherBySerial from 'my-phorest/gql/queries/get-voucher-by-serial.graphql';
import requestVoucherPrint from 'my-phorest/gql/mutations/request-voucher-receipt-print.graphql';

export default class VoucherReceiptService extends Service {
  @service('browser/window') window;
  @service electronApp;
  @service printingDevices;
  @service router;
  @service session;

  @queryManager apollo;

  @task
  *printInElectronTask(
    voucherIds,
    { branchId, forceLocalPrinting = false } = {}
  ) {
    yield this.electronApp.verifyHasPrinterToPrintTo();

    if (!forceLocalPrinting) {
      const remoteTargetId = yield this.electronApp.getRemotePrintingTarget();

      if (remoteTargetId) {
        const result = yield this.apollo.mutate(
          {
            mutation: requestVoucherPrint,
            variables: {
              voucherIds,
              printingDeviceId: remoteTargetId,
            },
          },
          'requestVoucherReceiptPrint'
        );
        this.printingDevices.showPrintRequestSentSuccessNotificationTask.perform(
          remoteTargetId
        );
        return result;
      }
    }

    for (let i = 0; i < voucherIds.length; i++) {
      const accountId = this.session.getAccountIdByBranchId(branchId);
      const path = this.router.urlFor(
        'accounts.account.print.voucher-receipt',
        accountId,
        voucherIds[i]
      );
      const { protocol, host } = this.window.location;
      const printURL = new URL(`${protocol}//${host}${path}`);

      yield new Promise((resolve) => {
        return this.electronApp.printReceipt(
          printURL.toString(),
          {
            successCb: resolve,
          },
          { waitForDataLoadedAttr: true }
        );
      });
    }
  }

  @task
  *getVoucherByIdTask(id) {
    return yield this.apollo.query(
      {
        query: GetVoucherById,
        variables: { id },
      },
      'voucher'
    );
  }

  @task
  *getVouchersByIdsTask(voucherIds) {
    let promises = voucherIds.map((voucherId) => {
      return this.getVoucherByIdTask.perform(voucherId);
    });
    return yield Promise.all(promises);
  }

  @task
  *getVoucherBySerialTask(serial, filterBy) {
    const variables = { serial };

    if (filterBy) {
      variables.filterBy = filterBy;
    }

    return yield this.apollo.query(
      {
        query: GetVoucherBySerial,
        variables,
      },
      'voucherBySerial'
    );
  }

  @task
  *getVouchersBySerialsTask(serials) {
    let promises = serials.map((serial) => {
      return this.getVoucherBySerialTask.perform(serial);
    });
    return yield Promise.all(promises);
  }
}
